<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">


        <el-form-item label="企业ID">
          <el-input size="small" v-model="searchForm.supply_id" placeholder="企业ID搜索">
          </el-input></el-form-item>
        <el-form-item label="商家ID">
          <el-input size="small" v-model="searchForm.supply_id" placeholder="商家ID搜索">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加分类</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="category_id" default-expand-all
                  :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
                  style="width: 100%" v-loading="loading">
          <el-table-column prop="supply_name" label="所属" width="180"></el-table-column>
          <el-table-column prop="name" label="分类名称" width="180">
            <template slot-scope="scope">
              <!-- 根据层级添加缩进 -->
              <span :style="{ paddingLeft: (getCategoryLevel(scope.row) * 20) + 'px' }">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="180">
            <template slot-scope="scope">
              <img v-img-url="hasImages(scope.row.images)" alt="" width="50px" />
            </template>
          </el-table-column>
          <el-table-column prop="product_num" label="商品数量"></el-table-column>
          <el-table-column prop="sort" label="分类排序"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import Project_categoryApi from '@/api/project_category.js';
  import Add from './Add.vue';
  import Edit from './Edit.vue';

  export default {
    components: {
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        categoryModel: {
          catList: [],
          model: {}
        },
        searchForm: {
          supply_id: ""
        }
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {

      hasImages(e) {
        if (e) {
          return e.file_path;
        } else {
          return '';
        }
      },
      onSubmit() {
        this.getData();
      },
      /*获取列表*/
      getData() {
        let self = this;
        Project_categoryApi.catList({
          supply_id: self.searchForm.supply_id
        }, true)
          .then(data => {
            self.loading = false;
            // 处理数据，确保所有层级都有正确的child结构
            self.tableData = self.processCategoryData(data.data.list);
            self.categoryModel.catList = self.tableData;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*处理分类数据，确保三级结构正确*/
      processCategoryData(categories) {
        if (!categories || !categories.length) return [];

        return categories.map(category => {
          // 确保child是数组格式
          if (category.child && typeof category.child === 'object' && !Array.isArray(category.child)) {
            // 如果是对象格式，转换为数组
            category.child = Object.values(category.child);
          }

          // 递归处理子分类
          if (category.child && category.child.length) {
            category.child = this.processCategoryData(category.child);
          } else {
            category.child = [];
          }

          return category;
        });
      },
      /*获取分类层级*/
      getCategoryLevel(category, level = 0) {
        // 这是一个辅助方法，用于确定分类的层级（用于缩进显示）
        return level;
      },
      /*打开添加*/
      addClick() {
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.categoryModel.model = item;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },
      /*删除分类*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          Project_categoryApi.catDel({
            category_id: row.category_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },
    }
  };
</script>

<style>
  /* 添加一些样式使层级关系更明显 */
  .el-table .el-table__row .el-table__cell {
    padding: 8px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/project_investment/category/index.vue